import http from './reddit'

export default {
  getSiteSelect: () => http.Get(`${http.url.Newcommon}/setpg`),  //取的占点列表
  getSitelist: (siteid) => http.Get(`${http.url.Newcommon}/setlinelist/${siteid}`), //线路列表
  setlineadd: (data) => http.Post(`${http.url.Newcommon}/setlineadd`, data), // 入口網站新增
  setlineupd: (data) => http.Post(`${http.url.Newcommon}/setlineupd`, data), // 入口網站修改
  //内页
  setlineInside: (setlineId) => http.Get(`${http.url.Newcommon}/setlineInside/${setlineId}`), // 内页列表
  setlineInsideAdd: (data) => http.Post(`${http.url.Newcommon}/setlineInsideAdd`, data), // 内页新增
  setlineInsideUpd: (data) => http.Post(`${http.url.Newcommon}/setlineInsideUpd`, data), // 内页修改
  //页码
  setpgSetting: () => http.Get(`${http.url.Newcommon}/setpgSetting`), // 页码列表
  setpgSettingUpd: (data) => http.Post(`${http.url.Newcommon}/setpgSettingUpd`, data) // 页码列表
}